import React from 'react';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {frase} from '../../frase';
import {skinCorrente, eColore, inAnteprima} from '../../skin';
import {pagineAiuto, pieDiPagina, sezioniAccese} from '../../moduli/leggi';
import {lingua, lingueDisponibili, impostaLingua} from '../../preferenze';
import SkinLogo from '../Shell/SkinLogo';
import IconaNova from './IconaNova';
import TickerCripto from './TickerCripto';
import {fraseLegale} from '../../utils/testiLegali';

/* I testi di serie del catalogo (titoli delle colonne, riquadri dei punti di
   forza, titoli delle pagine di Aiuto): segnati qui per il dizionario, si
   traducono con t() finche' la skin non ne scrive uno suo. */
frase('Giochi'); frase('Informazioni'); frase('Aiuto'); frase('Promozioni');
frase('Dal 2016'); frase('Dieci anni di gioco online');
frase('Prelievi istantanei'); frase('In cripto, senza attese');
frase('6.900+ giochi'); frase('Slot, live casino e altro');
frase('Assistenza 24/7'); frase('Sempre qualcuno a rispondere');
frase('Chi siamo'); frase('Regolamento'); frase('Assistenza');
frase('Termini dei bonus'); frase('Privacy'); frase('Cookie');

/* Le pagine di Aiuto che vanno nella colonna Aiuto; tutte le altre stanno in Informazioni. */
const NELLA_COLONNA_AIUTO = ['assistenza'];
const GIOCO_RESPONSABILE = {nome: frase('Gioco responsabile'), indirizzo: '/gioco-responsabile'};

/* I social: il disegno pieno del marchio, in un quadrato 24x24. */
const SOCIAL = {
  telegram: {nome: 'Telegram', d: 'M21.4 3.6 2.9 10.8c-1.2.5-1.2 1.6 0 2l4.7 1.5 1.8 5.6c.3.8.6 1 1.2 1 .5 0 .8-.2 1.1-.5l2.6-2.5 5 3.7c.9.5 1.6.2 1.8-.9l3.3-15.4c.3-1.4-.6-2-1.5-1.7zM9.7 14.6l8.6-7.8c.4-.3-.1-.5-.6-.2l-10.6 6.7'},
  x: {nome: 'X', d: 'M17.8 3h3.1l-6.8 7.8L22 21h-6.3l-4.9-6.4L5.2 21H2.1l7.3-8.3L1.8 3h6.4l4.4 5.9zm-1.1 16.2h1.7L7.3 4.7H5.5z'},
  instagram: {nome: 'Instagram', d: 'M12 2.2c3.2 0 3.6 0 4.8.1 3.3.1 4.8 1.7 4.9 4.9.1 1.3.1 1.6.1 4.8s0 3.6-.1 4.8c-.1 3.2-1.7 4.8-4.9 4.9-1.3.1-1.6.1-4.8.1s-3.6 0-4.8-.1c-3.3-.1-4.8-1.7-4.9-4.9C2.2 15.6 2.2 15.2 2.2 12s0-3.6.1-4.8C2.4 3.9 3.9 2.4 7.2 2.3c1.2-.1 1.6-.1 4.8-.1zm0 4.7a5.1 5.1 0 1 0 0 10.2 5.1 5.1 0 0 0 0-10.2zm0 8.4a3.3 3.3 0 1 1 0-6.6 3.3 3.3 0 0 1 0 6.6zm5.3-9.8a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4z'},
  facebook: {nome: 'Facebook', d: 'M22 12a10 10 0 1 0-11.6 9.9v-7H7.9V12h2.5V9.8c0-2.5 1.5-3.9 3.8-3.9 1.1 0 2.2.2 2.2.2v2.5h-1.3c-1.2 0-1.6.8-1.6 1.6V12h2.8l-.4 2.9h-2.3v7A10 10 0 0 0 22 12z'},
  tiktok: {nome: 'TikTok', d: 'M16.6 2h-3.3v13.4a2.9 2.9 0 1 1-2-2.8V9.2a6.2 6.2 0 1 0 5.3 6.2V8.6a8 8 0 0 0 4.7 1.5V6.8a4.7 4.7 0 0 1-4.7-4.8z'},
  youtube: {nome: 'YouTube', d: 'M23 7.2a3 3 0 0 0-2.1-2.1C19 4.6 12 4.6 12 4.6s-7 0-8.9.5A3 3 0 0 0 1 7.2 31 31 0 0 0 .5 12a31 31 0 0 0 .5 4.8 3 3 0 0 0 2.1 2.1c1.9.5 8.9.5 8.9.5s7 0 8.9-.5a3 3 0 0 0 2.1-2.1 31 31 0 0 0 .5-4.8 31 31 0 0 0-.5-4.8zM9.8 15V9l5.8 3z'},
  discord: {nome: 'Discord', d: 'M20.3 4.4A19.8 19.8 0 0 0 15.4 3l-.6 1.3a18.4 18.4 0 0 0-5.6 0L8.6 3a19.7 19.7 0 0 0-4.9 1.5C.6 9.1-.3 13.7.1 18.2a19.9 19.9 0 0 0 6 3l1.3-2.1c-.7-.3-1.4-.6-2-1l.5-.4a14.2 14.2 0 0 0 12.2 0l.5.4c-.6.4-1.3.7-2 1l1.3 2.1a19.8 19.8 0 0 0 6-3c.5-5.2-.8-9.8-3.6-13.8zM8 15.4c-1.2 0-2.2-1.1-2.2-2.4S6.8 10.6 8 10.6s2.2 1.1 2.2 2.4-1 2.4-2.2 2.4zm8 0c-1.2 0-2.2-1.1-2.2-2.4s1-2.4 2.2-2.4 2.2 1.1 2.2 2.4-1 2.4-2.2 2.4z'},
};

/** Un collegamento del piede: una pagina del sito con Link, un sito esterno in una scheda nuova. */
function Voce({indirizzo, children}) {
  if (indirizzo.startsWith('/')) return <Link to={indirizzo}>{children}</Link>;
  return <a href={indirizzo} target={'_blank'} rel={'noopener noreferrer'}>{children}</a>;
}

/**
 * IL PIEDE DI PAGINA NOVA, dall'alto in basso:
 *   1. il ticker delle criptovalute accettate;
 *   2. i punti di forza, quattro riquadri con icona;
 *   3. logo con frase e social, e le colonne di collegamenti (Giochi,
 *      Promozioni, Informazioni, Aiuto);
 *   4. 18+, gli enti del gioco responsabile, il sigillo e la riga della licenza;
 *   5. copyright e lingua.
 *
 * E' sempre il modulo «Piè di pagina» della skin a decidere COSA c'e': ogni
 * blocco si accende o si spegne e ha i suoi testi (Skin › Moduli › Piè di
 * pagina). Niente di inventato per chi gioca: senza società la riga della
 * licenza non c'e', un social senza indirizzo non c'e', una colonna senza
 * voci non c'e'. I loghi Visa e PayPal di prima non ci sono piu': il
 * versamento e' in cripto e le monete le mostra il ticker.
 */
export default function PiedeNova() {
  const {t} = useTranslation();
  const skin = skinCorrente();
  const piede = pieDiPagina();
  const lingue = lingueDisponibili();
  const anteprima = inAnteprima();

  /* Le pagine di Aiuto accese, divise fra Informazioni e Aiuto. */
  const aiuto = pagineAiuto().filter((p) => p.acceso).map((p) => ({chiave: p.chiave, nome: p.titolo, indirizzo: p.percorso}));
  const colonne = [
    piede.colonnaGiochi.acceso && {
      chiave: 'giochi', titolo: piede.colonnaGiochi.titolo,
      voci: sezioniAccese().map((s) => ({nome: s.nome, indirizzo: s.percorso})).concat(piede.colonnaGiochi.voci),
    },
    piede.colonnaPromozioni.acceso && {chiave: 'promozioni', titolo: piede.colonnaPromozioni.titolo, voci: piede.colonnaPromozioni.voci},
    piede.informazioni.acceso && {
      chiave: 'informazioni', titolo: piede.informazioni.titolo,
      voci: aiuto.filter((p) => !NELLA_COLONNA_AIUTO.includes(p.chiave)).concat(piede.informazioni.voci),
    },
    piede.colonnaAiuto.acceso && {
      chiave: 'aiuto', titolo: piede.colonnaAiuto.titolo, email: piede.colonnaAiuto.email,
      voci: aiuto.filter((p) => NELLA_COLONNA_AIUTO.includes(p.chiave))
          .concat(piede.giocoResponsabile.acceso ? [GIOCO_RESPONSABILE] : [], piede.colonnaAiuto.voci),
    },
  ].filter((c) => c && (c.voci.length || c.email));
  const marchio = piede.marchio.acceso;

  const stile = {};
  if (piede.colori) {
    if (eColore(piede.colori.sfondo)) stile['--lvc-pie-sfondo'] = piede.colori.sfondo.trim();
    if (eColore(piede.colori.testo)) stile['--lvc-pie-testo'] = piede.colori.testo.trim();
  }

  const legale = piede.legale;
  const rigaLegale = legale.testo || (legale.societa ? fraseLegale(legale, t) : '');
  const testoResponsabile = typeof piede.giocoResponsabile.testo === 'string' ? piede.giocoResponsabile.testo.trim() : '';
  const loghiEnti = Array.isArray(piede.giocoResponsabile.loghiEnti)
    ? piede.giocoResponsabile.loghiEnti.filter((u) => typeof u === 'string' && u.trim()) : [];
  const fasciaLegale = piede.giocoResponsabile.acceso || (legale.acceso && (rigaLegale || legale.sigillo || anteprima));

  return (
    <footer className={'nova-piede'} style={stile}>
      {/* 1. Le criptovalute accettate con NOWPayments, in una striscia che scorre: decorativa, non si clicca. */}
      {piede.cripto.acceso && <TickerCripto/>}

      {/* 2. I punti di forza. */}
      {piede.fiducia.acceso && (
        <ul className={'nova-fiducia'} aria-label={t('Perché sceglierci')}>
          {piede.fiducia.voci.map((v, i) => (
            <li key={i}>
              <span className={'nova-fiducia-icona'}><IconaNova nome={v.icona || 'stella'} misura={26}/></span>
              <span><b>{t(v.titolo)}</b>{v.testo && <small>{t(v.testo)}</small>}</span>
            </li>
          ))}
        </ul>
      )}

      {/* 3. Logo e social, le colonne di collegamenti. */}
      {(marchio || colonne.length > 0) && (
        <div className={'nova-piede-colonne' + (marchio ? ' con-marchio' : '')}>
          {marchio && (
            <div className={'nova-piede-marchio'}>
              <div className={'nova-piede-logo'}><SkinLogo/></div>
              {piede.marchio.frase && <p>{piede.marchio.frase}</p>}
              {piede.marchio.social.length > 0 && (
                <ul className={'nova-social'} aria-label={t('Seguici')}>
                  {piede.marchio.social.map((s) => (
                    <li key={s.chiave}>
                      <a href={s.indirizzo} target={'_blank'} rel={'noopener noreferrer'} aria-label={SOCIAL[s.chiave].nome} title={SOCIAL[s.chiave].nome}>
                        <svg viewBox={'0 0 24 24'} aria-hidden={'true'} focusable={'false'}><path d={SOCIAL[s.chiave].d}/></svg>
                      </a>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          )}
          {colonne.map((c) => (
            <nav key={c.chiave} className={'nova-piede-colonna'} aria-label={t(c.titolo)}>
              <h3>{t(c.titolo)}</h3>
              <ul>
                {c.voci.map((v) => <li key={v.indirizzo + v.nome}><Voce indirizzo={v.indirizzo}>{t(v.nome)}</Voce></li>)}
                {c.email && <li><a href={'mailto:' + c.email}>{c.email}</a></li>}
              </ul>
            </nav>
          ))}
        </div>
      )}

      {/* 4. Gioco responsabile e licenza. */}
      {fasciaLegale && (
        <div className={'nova-licenza'}>
          <div className={'nova-licenza-loghi'}>
            <span className={'nova-18'} aria-label={t('Vietato ai minori di 18 anni')}>18+</span>
            {piede.giocoResponsabile.acceso && piede.giocoResponsabile.enti.map((e) => (
              <a key={e.indirizzo} className={'nova-ente'} href={e.indirizzo} target={'_blank'} rel={'noopener noreferrer'}>{e.nome}</a>
            ))}
            {piede.giocoResponsabile.acceso && loghiEnti.map((u) => <img key={u} className={'nova-ente-logo'} src={u} alt={''}/>)}
            {legale.acceso && legale.sigillo && (legale.verifica
              ? <a className={'nova-sigillo'} href={legale.verifica} target={'_blank'} rel={'noopener noreferrer'}><img src={legale.sigillo} alt={t('Verifica la licenza')}/></a>
              : <span className={'nova-sigillo'}><img src={legale.sigillo} alt={t('Sigillo della licenza')}/></span>)}
          </div>
          <div className={'nova-licenza-testi'}>
            {legale.acceso && rigaLegale && <p>{rigaLegale}</p>}
            {legale.acceso && !rigaLegale && anteprima && (
              <p className={'nova-licenza-vuota'}>{t('Qui va la riga della licenza (società, sede, ente e numero di licenza): si scrive dal backoffice, Moduli → Piè di pagina → Fascia legale. Finché manca, chi gioca non la vede.')}</p>
            )}
            {piede.giocoResponsabile.acceso && (
              <p>{testoResponsabile || t('Il gioco è vietato ai minori di 18 anni e può causare dipendenza. Gioca responsabilmente: imposta limiti di deposito e di perdita, prenditi una pausa o autoescluditi dalla pagina Gioco responsabile.')}</p>
            )}
          </div>
        </div>
      )}

      {/* 5. Copyright e lingua. */}
      <div className={'nova-piede-fondo'}>
        <p className={'nova-copy'}>© {new Date().getFullYear()} {(skin && skin.name) || ''}. {t('Tutti i diritti riservati.')}</p>
        {lingue.length > 1 && (
          <select className={'nova-lingua'} aria-label={t('Lingua')} value={lingua()} onChange={(e) => impostaLingua(e.target.value)}>
            {lingue.map((l) => <option key={l.codice} value={l.codice} lang={l.codice}>{l.nome}</option>)}
          </select>
        )}
      </div>
    </footer>
  );
}
